export const siteInfo = {
  name: '哔咔动漫',
  tagline: '追更漫画连载实时更新',
  slogan: '好看的漫画推荐与热门排行，哔咔动漫追番不停',
  description: '哔咔动漫是国内领先的漫画追更与推荐平台，聚合全网热门漫画连载实时更新信息。无论你是追更党还是新入坑的动漫爱好者，这里都有编辑精心筛选的高分漫画推荐与实时热门排行，帮你最快找到值得追的作品，追番体验从此不再迷茫。',
  heroStats: [
    { label: '每日更新', value: '200+ 话' },
    { label: '收录作品', value: '30,000+' },
    { label: '活跃读者', value: '500 万+' },
  ],
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '专题索引', href: '#index' },
  { label: '常见问答', href: '#faq' },
  { label: '读者评论', href: '#comments' },
  { label: '热门排行', href: '#ranking' },
  { label: 'App 下载', href: '#app' },
];

export const cards = [
  {
    title: '鬼灭之刃 无限城篇',
    tag: '热血',
    summary: '炭治郎一行突入无限城，与上弦之鬼的最终决战全面爆发，每一话都是视觉盛宴。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20demon%20slayer%20style%20illustration%20with%20swordsman%20in%20dark%20castle%2C%20dramatic%20fire%20effects%2C%20intense%20action%20scene%2C%20warm%20orange%20and%20red%20color%20palette%2C%20Japanese%20anime%20art%20style%2C%20detailed%20character%20design%2C%20cinematic%20lighting&width=400&height=280&seq=card-01&orientation=landscape',
    alt: '鬼灭之刃无限城篇推荐',
    hot: true,
  },
  {
    title: '咒术回战 死灭回游',
    tag: '战斗',
    summary: '虎杖与伏黑面对史上最强咒术师，死灭回游篇进入白热化阶段，剧情反转不断。',
    img: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20style%20anime%20art%2C%20sorcerer%20battle%20scene%20with%20dark%20energy%20and%20cursed%20spirits%2C%20urban%20Tokyo%20night%20setting%2C%20dynamic%20action%20pose%2C%20neon%20purple%20and%20red%20accents%2C%20high%20contrast%20illustration&width=400&height=280&seq=card-02&orientation=landscape',
    alt: '咒术回战死灭回游推荐',
    hot: true,
  },
  {
    title: '间谍过家家 第二季',
    tag: '喜剧',
    summary: '劳埃德一家的日常任务继续上演，安妮亚的校园生活与新敌人的出现让故事更有趣。',
    img: 'https://readdy.ai/api/search-image?query=Spy%20family%20anime%20style%20illustration%2C%20warm%20family%20scene%20with%20a%20gentleman%20spy%20and%20pink%20haired%20girl%2C%20European%20city%20background%2C%20cozy%20and%20humorous%20vibe%2C%20soft%20warm%20lighting%2C%20pastel%20color%20palette&width=400&height=280&seq=card-03&orientation=landscape',
    alt: '间谍过家家第二季推荐',
  },
  {
    title: '电锯人 第二部',
    tag: '暗黑',
    summary: '藤本树继续突破想象力的极限，电次在新篇章中面临更疯狂的敌人和更残酷的选择。',
    img: 'https://readdy.ai/api/search-image?query=Chainsaw%20Man%20anime%20style%20dark%20illustration%2C%20chaotic%20urban%20battle%20with%20chainsaw%20weapon%2C%20gritty%20and%20raw%20art%20style%2C%20blood%20red%20and%20dark%20grey%20color%20scheme%2C%20intense%20horror%20action%2C%20Japanese%20manga%20aesthetic&width=400&height=280&seq=card-04&orientation=landscape',
    alt: '电锯人第二部推荐',
  },
  {
    title: '葬送的芙莉莲',
    tag: '奇幻',
    summary: '精灵魔法使芙莉莲踏上理解人类的旅程，温暖而深沉的故事让无数读者落泪。',
    img: 'https://readdy.ai/api/search-image?query=Frieren%20anime%20style%20fantasy%20illustration%2C%20elf%20mage%20walking%20through%20a%20peaceful%20meadow%20at%20sunset%2C%20nostalgic%20and%20gentle%20atmosphere%2C%20soft%20golden%20lighting%2C%20beautiful%20landscape%20with%20flowers%2C%20minimalist%20composition&width=400&height=280&seq=card-05&orientation=landscape',
    alt: '葬送的芙莉莲推荐',
  },
  {
    title: '海贼王 艾尔巴夫篇',
    tag: '冒险',
    summary: '路飞一行终于抵达巨人王国艾尔巴夫，传说中的巨大战争即将揭开帷幕。',
    img: 'https://readdy.ai/api/search-image?query=One%20Piece%20anime%20style%20adventure%20illustration%2C%20pirate%20crew%20on%20a%20giant%20mythical%20island%2C%20tropical%20ocean%20and%20ancient%20ruins%2C%20vibrant%20blue%20sky%20and%20green%20landscape%2C%20exciting%20and%20grand%20scale%2C%20Japanese%20shonen%20art&width=400&height=280&seq=card-06&orientation=landscape',
    alt: '海贼王艾尔巴夫篇推荐',
  },
  {
    title: '怪兽8号',
    tag: '科幻',
    summary: '中年大叔变身为最强怪兽战士，热血与幽默并存的科幻战斗番引爆全网讨论。',
    img: 'https://readdy.ai/api/search-image?query=Kaiju%20No%208%20anime%20style%20sci%20fi%20illustration%2C%20giant%20monster%20and%20military%20soldier%20in%20futuristic%20city%2C%20explosive%20action%20scene%2C%20blue%20and%20white%20energy%20effects%2C%20modern%20mecha%20aesthetic%2C%20dynamic%20composition&width=400&height=280&seq=card-07&orientation=landscape',
    alt: '怪兽8号推荐',
  },
];

export const indexItems = [
  {
    title: '本周必追新番',
    count: 24,
    icon: 'ri-fire-line',
    desc: '编辑精选本周最值得追更的连载作品',
  },
  {
    title: '恋爱喜剧专题',
    count: 18,
    icon: 'ri-hearts-line',
    desc: '甜到爆炸的恋爱喜剧漫画合集',
  },
  {
    title: '悬疑推理特辑',
    count: 15,
    icon: 'ri-search-eye-line',
    desc: '烧脑反转不断的悬疑推理神作',
  },
  {
    title: '热血战斗合集',
    count: 32,
    icon: 'ri-sword-line',
    desc: '燃到停不下来的热血战斗漫画',
  },
  {
    title: '异世界转生',
    count: 28,
    icon: 'ri-earth-line',
    desc: '最受欢迎的异世界转生题材精选',
  },
  {
    title: '国漫崛起',
    count: 20,
    icon: 'ri-china-railway-line',
    desc: '优质国产漫画连载推荐与盘点',
  },
  {
    title: '完结神作补番',
    count: 16,
    icon: 'ri-check-double-line',
    desc: '已经完结的高分经典漫画一键补番',
  },
  {
    title: '冷门佳作发掘',
    count: 12,
    icon: 'ri-lightbulb-flash-line',
    desc: '被埋没的高质量冷门漫画推荐',
  },
];

export const faqItems = [
  {
    q: '哔咔动漫的漫画更新速度有多快？',
    a: '哔咔动漫对接主流漫画平台的实时更新源，热门连载作品通常会在官方更新后 30 分钟内同步上线。编辑团队 7×24 小时值班，确保你不会错过任何一话更新。同时支持更新推送提醒，你可以订阅喜欢的作品，第一时间收到更新通知。',
  },
  {
    q: '如何在哔咔动漫找到适合自己口味的漫画？',
    a: '我们有多种方式帮你发现好漫画：首页热门排行展示全网最火的作品，专题索引按题材分类整理推荐清单，编辑精选卡片每周更新高分作品。你还可以通过话题标签浏览同类型漫画，或查看读者评论区的真实口碑来做出选择。',
  },
  {
    q: '哔咔动漫的推荐排名是根据什么来的？',
    a: '热门排行综合了读者评分、阅读量、讨论热度和编辑评价等多个维度，通过算法加权计算得出。我们坚持数据透明，每部作品的评分和热度都有据可查，拒绝刷榜和虚假数据，确保推荐公平可信。',
  },
  {
    q: '哔咔动漫支持手机端阅读吗？',
    a: '当然支持！哔咔动漫已经推出 iOS 和 Android 客户端，针对手机屏幕做了深度适配，滑动翻页流畅，夜间模式护眼舒适。你可以在应用商店搜索"哔咔动漫"下载，也可以在本页底部的 App 下载区域扫码安装。',
  },
];

export const carouselItems = [
  {
    title: '2026 夏季新番导览',
    subtitle: '编辑精选 · 15 部必看',
    desc: '今年夏季档新番质量爆表，从热血战斗到治愈日常，我们帮你提前锁定最值得追的作品清单。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20anime%20collage%20with%20multiple%20colorful%20character%20illustrations%2C%20beach%20and%20summer%20vibes%2C%20bright%20sunny%20sky%2C%20Japanese%20anime%20promotional%20poster%20style%2C%20vibrant%20colors%2C%20energetic%20composition%2C%20festival%20atmosphere&width=600&height=400&seq=carousel-01&orientation=landscape',
    alt: '2026夏季新番导览',
    tag: '新番速递',
  },
  {
    title: 'JUMP 连载战力榜',
    subtitle: '每周更新 · 实时排行',
    desc: '少年 JUMP 当家连载最新热度排名，看看你追的作品本周排第几。',
    img: 'https://readdy.ai/api/search-image?query=Shonen%20Jump%20magazine%20style%20illustration%20with%20multiple%20action%20hero%20characters%20in%20dynamic%20poses%2C%20bold%20typography%2C%20comic%20book%20layout%2C%20red%20and%20black%20color%20scheme%2C%20energetic%20manga%20style&width=600&height=400&seq=carousel-02&orientation=landscape',
    alt: 'JUMP连载战力榜',
    tag: '排行速报',
  },
  {
    title: '国漫精品推荐月榜',
    subtitle: '编辑力荐 · 10 部佳作',
    desc: '国产漫画越来越能打了！本月编辑团队精选的十部国漫精品，画风和故事都不输日漫。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20martial%20arts%20characters%20in%20ancient%20Chinese%20setting%2C%20ink%20wash%20painting%20and%20modern%20anime%20fusion%2C%20elegant%20flowing%20robes%2C%20misty%20mountain%20landscape%2C%20golden%20and%20jade%20color%20palette&width=600&height=400&seq=carousel-03&orientation=landscape',
    alt: '国漫精品推荐月榜',
    tag: '编辑推荐',
  },
  {
    title: '动画化作品前瞻',
    subtitle: '即将开播 · 8 部确认',
    desc: '这些还在连载的漫画已经确定动画化了！趁开播之前先补完原作，做最懂行的追番党。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20adaptation%20announcement%20style%20illustration%2C%20manga%20pages%20transitioning%20into%20anime%20frames%2C%20cinematic%20movie%20poster%20aesthetic%2C%20dramatic%20spotlight%20effect%2C%20excited%20audience%20silhouette%2C%20theater%20atmosphere&width=600&height=400&seq=carousel-04&orientation=landscape',
    alt: '动画化作品前瞻',
    tag: '前瞻情报',
  },
  {
    title: '校园恋爱漫画特辑',
    subtitle: '甜度拉满 · 20 部纯爱',
    desc: '春天虽然过了，但甜甜的校园恋爱故事永远值得一看。从经典到新作，糖分补给站。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20school%20anime%20style%20illustration%20with%20cherry%20blossoms%20and%20couple%20under%20a%20tree%2C%20soft%20pink%20and%20white%20color%20palette%2C%20gentle%20spring%20lighting%2C%20youthful%20and%20sweet%20atmosphere%2C%20Japanese%20high%20school%20setting&width=600&height=400&seq=carousel-05&orientation=landscape',
    alt: '校园恋爱漫画特辑',
    tag: '专题策划',
  },
  {
    title: '恐怖漫画之夜',
    subtitle: '胆量挑战 · 12 部精选',
    desc: '深夜慎入！从伊藤润二到新兴恐怖漫画家，这些作品让你后背发凉却根本停不下来。',
    img: 'https://readdy.ai/api/search-image?query=Horror%20manga%20style%20dark%20illustration%20with%20mysterious%20shadow%20figure%20in%20old%20Japanese%20house%2C%20eerie%20moonlight%2C%20creepy%20atmosphere%2C%20black%20and%20white%20high%20contrast%2C%20Junji%20Ito%20inspired%20spiral%20patterns%2C%20psychological%20horror&width=600&height=400&seq=carousel-06&orientation=landscape',
    alt: '恐怖漫画之夜',
    tag: '深夜专题',
  },
];

export const aboutContent = {
  title: '关于哔咔动漫',
  paragraphs: [
    '哔咔动漫诞生于一群资深漫画爱好者的热情。我们深知找一部好漫画有多不容易——信息太散、推荐太杂、更新太慢。于是我们决定自己做一个平台，把最好的漫画用最简单的方式呈现给每一位同好。',
    '从最初的手工整理榜单，到如今覆盖数万部作品的智能推荐系统，哔咔动漫始终坚守一个核心理念：让每一个打开哔咔动漫的人，都能在五分钟内找到自己想追的漫画。我们不追求大而全，只推荐真正值得花时间的好作品。',
    '编辑团队由资深漫评人、二次元文化研究者组成，每周产出超过 50 篇原创推荐内容。我们相信，好的推荐应该像朋友安利一样真诚，而不是冷冰冰的算法输出。',
  ],
  img: 'https://readdy.ai/api/search-image?query=Cozy%20manga%20reading%20room%20with%20wooden%20bookshelves%20filled%20with%20colorful%20manga%20volumes%2C%20warm%20lamp%20lighting%2C%20comfortable%20armchair%2C%20tea%20cup%20on%20side%20table%2C%20peaceful%20reading%20atmosphere%2C%20Japanese%20interior%20design%20elements&width=600&height=400&seq=about-01&orientation=landscape',
  alt: '哔咔动漫品牌介绍',
};

export const comments = [
  {
    name: '追番老司机阿强',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20avatar%20portrait%2C%20young%20man%20with%20glasses%2C%20friendly%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    text: '用了哔咔动漫半年了，追更体验真的好。更新快、推荐准，最重要的是没有乱七八糟的广告弹窗。编辑部是真的懂漫画，每次推荐的冷门佳作都让人惊喜。',
    date: '2026-07-25',
    source: '来自 App Store',
  },
  {
    name: '樱花落尽',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20portrait%2C%20young%20woman%20with%20long%20dark%20hair%2C%20gentle%20expression%2C%20soft%20pink%20background%2C%20clean%20illustration%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    text: '作为一个恋爱漫画重度爱好者，哔咔的恋爱专题做得太棒了！分类很细，推荐质量高，我已经在这里补完了十几部经典作品，每周都来看更新。',
    date: '2026-07-23',
    source: '来自微博',
  },
  {
    name: '次元穿梭者',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20avatar%20portrait%2C%20teenager%20with%20spiky%20hair%2C%20energetic%20expression%2C%20blue%20background%2C%20clean%20illustration%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    text: '排名机制很公平，不会被水军刷榜。这点在现在的漫画平台里太难得了。希望哔咔一直保持这种态度，真正的漫画迷需要这样的净土。',
    date: '2026-07-20',
    source: '来自贴吧',
  },
  {
    name: '画江湖之不良人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20avatar%20portrait%2C%20young%20man%20with%20headband%2C%20martial%20arts%20vibe%2C%20warm%20orange%20background%2C%20clean%20illustration%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    text: '国漫板块做得越来越好了，很多优秀的国产漫画在这里被更多人看到。编辑的推荐文案写得很用心，不是那种敷衍的模板文，能感觉到是真的看过才推荐的。',
    date: '2026-07-18',
    source: '来自知乎',
  },
  {
    name: '星海旅人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20portrait%2C%20young%20woman%20with%20short%20blue%20hair%2C%20cool%20expression%2C%20purple%20background%2C%20clean%20illustration%20style&width=80&height=80&seq=avatar-05&orientation=squarish',
    text: '最惊喜的是 FAQ 问答区和话题标签功能，帮我快速找到了好多同类型的好漫画。界面设计也很清爽，晚上开夜间模式追更完全不会累眼睛。',
    date: '2026-07-15',
    source: '来自小红书',
  },
];

export const updates = [
  {
    date: '2026-07-28',
    tag: '更新',
    title: '《鬼灭之刃》无限城篇 第 187 话更新',
    desc: '炭治郎与义勇联手对抗上弦之三，战斗进入最高潮。',
  },
  {
    date: '2026-07-28',
    tag: '新作',
    title: '《放学后失眠的你》作者新连载启动',
    desc: '温情派漫画家オジロマコト全新校园题材作品今日上线。',
  },
  {
    date: '2026-07-27',
    tag: '动画化',
    title: '《SAKAMOTO DAYS》动画化正式官宣',
    desc: '坂本商店的杀手日常确定 2027 年 1 月开播，PV 已公开。',
  },
  {
    date: '2026-07-27',
    tag: '排行',
    title: '本周热门排行大洗牌',
    desc: '《怪兽 8 号》登顶，《咒术回战》紧随其后，《芙莉莲》稳居前三。',
  },
  {
    date: '2026-07-26',
    tag: '完结',
    title: '《我心里危险的东西》最终话发布',
    desc: '京太郎与杏奈的青春恋爱故事迎来感动大结局。',
  },
  {
    date: '2026-07-26',
    tag: '专题',
    title: '「夏日恐怖特辑」专题上线',
    desc: '精选 15 部让你在炎热夏天后背发凉的恐怖漫画。',
  },
  {
    date: '2026-07-25',
    tag: '活动',
    title: '「哔咔读者最喜爱漫画」投票开启',
    desc: '年度读者票选活动正式开始，为你喜欢的作品投出关键一票。',
  },
];

export const rankingItems = [
  { rank: 1, title: '鬼灭之刃 无限城篇', tag: '热血', score: '9.8', trend: 'up' },
  { rank: 2, title: '怪兽 8 号', tag: '科幻', score: '9.6', trend: 'up' },
  { rank: 3, title: '葬送的芙莉莲', tag: '奇幻', score: '9.7', trend: 'stable' },
  { rank: 4, title: '咒术回战 死灭回游', tag: '战斗', score: '9.5', trend: 'up' },
  { rank: 5, title: '海贼王 艾尔巴夫篇', tag: '冒险', score: '9.4', trend: 'stable' },
  { rank: 6, title: '电锯人 第二部', tag: '暗黑', score: '9.3', trend: 'up' },
  { rank: 7, title: '间谍过家家 第二季', tag: '喜剧', score: '9.2', trend: 'stable' },
];

export const appContent = {
  title: '随时随地，追更不停',
  subtitle: '哔咔动漫 App 已上架各大应用商店',
  desc: '专为移动端深度优化的阅读体验，支持离线缓存、夜间模式、更新推送。在手机和平板上享受流畅的漫画追更之旅。',
  features: ['滑动翻页流畅', '夜间模式护眼', '更新实时推送', '离线缓存阅读', '多设备同步', '个性化推荐'],
  img: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20colorful%20manga%20reader%20app%20interface%2C%20Japanese%20anime%20style%20UI%20design%2C%20clean%20modern%20mobile%20app%2C%20on%20a%20wooden%20desk%20with%20warm%20ambient%20lighting%2C%20minimalist%20product%20photography&width=400&height=700&seq=app-01&orientation=portrait',
  alt: '哔咔动漫App展示',
};

export const topics = [
  { name: '热血少年漫', count: '2.3 万讨论', icon: 'ri-fire-line' },
  { name: '悬疑推理', count: '1.8 万讨论', icon: 'ri-search-eye-line' },
  { name: '恋爱喜剧', count: '2.1 万讨论', icon: 'ri-hearts-line' },
  { name: '异世界转生', count: '1.5 万讨论', icon: 'ri-earth-line' },
  { name: '国漫精选', count: '1.2 万讨论', icon: 'ri-china-railway-line' },
  { name: '恐怖灵异', count: '9,800 讨论', icon: 'ri-ghost-line' },
  { name: '运动竞技', count: '8,500 讨论', icon: 'ri-basketball-line' },
  { name: '美食漫画', count: '6,200 讨论', icon: 'ri-restaurant-line' },
  { name: '科幻机甲', count: '7,800 讨论', icon: 'ri-rocket-line' },
];

export const contactContent = {
  title: '联系我们',
  subtitle: '投稿、合作、反馈 — 我们期待听到你的声音',
  desc: '如果你是漫画创作者希望作品被推荐，或是品牌方寻求合作，欢迎通过以下方式联系我们。读者反馈和建议同样是我们进步的动力。',
  email: 'contact@pikaanime.com',
  weibo: '@哔咔动漫官方',
  wechat: 'pika_anime_official',
};

export const features = [
  {
    title: '实时更新追踪',
    desc: '热门连载 30 分钟内同步，绝不让你错过任何一话更新。',
    icon: 'ri-timer-flash-line',
  },
  {
    title: '智能推荐算法',
    desc: '基于多维数据的公平排行，拒绝水军刷榜，推荐真实可信。',
    icon: 'ri-brain-line',
  },
  {
    title: '资深编辑团队',
    desc: '每篇推荐都经过专业编辑审核，保证内容质量与推荐诚意。',
    icon: 'ri-team-line',
  },
  {
    title: '纯净阅读体验',
    desc: '无弹窗广告、无恶意跳转，专注漫画内容本身的沉浸式体验。',
    icon: 'ri-shield-check-line',
  },
  {
    title: '多端无缝同步',
    desc: 'Web、iOS、Android 全平台覆盖，阅读进度实时云同步。',
    icon: 'ri-device-line',
  },
];

export const mediaItems = [
  {
    title: '【漫评】为什么《葬送的芙莉莲》是今年最好的奇幻漫画',
    duration: '18:24',
    views: '32.5 万',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20with%20Frieren%20anime%20character%20in%20a%20magical%20forest%2C%20YouTube%20style%20layout%20with%20play%20button%2C%20soft%20golden%20lighting%2C%20professional%20review%20aesthetic%2C%20clean%20typography%20overlay&width=600&height=340&seq=media-01&orientation=landscape',
    alt: '葬送的芙莉莲漫评视频',
  },
  {
    title: '【盘点】2026 上半年最值得补的 10 部漫画',
    duration: '22:10',
    views: '28.7 万',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20with%20manga%20book%20stack%20and%20ranking%20numbers%2C%20top%2010%20list%20style%2C%20colorful%20manga%20covers%20collage%2C%20YouTube%20review%20channel%20aesthetic%2C%20bright%20studio%20lighting&width=600&height=340&seq=media-02&orientation=landscape',
    alt: '2026上半年补番盘点视频',
  },
  {
    title: '【访谈】国内漫画编辑谈：什么样的漫画容易火',
    duration: '35:42',
    views: '19.3 万',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20with%20manga%20editor%20interview%20studio%20setting%2C%20two%20people%20talking%20with%20manga%20pages%20on%20table%2C%20professional%20podcast%20style%2C%20warm%20studio%20lighting%2C%20clean%20background&width=600&height=340&seq=media-03&orientation=landscape',
    alt: '漫画编辑访谈视频',
  },
  {
    title: '【对比】同一部漫画，动画和原作画风差别有多大',
    duration: '15:08',
    views: '41.2 万',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20showing%20split%20screen%20comparison%20of%20manga%20page%20versus%20anime%20frame%2C%20side%20by%20side%20layout%2C%20colorful%20anime%20and%20black%20white%20manga%20contrast%2C%20analysis%20video%20style&width=600&height=340&seq=media-04&orientation=landscape',
    alt: '动画与漫画对比视频',
  },
];